module.exports = __webpack_public_path__ + "static/media/alertYellow.af460dae.svg";